import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { device } from '../../../atoms/Utlis/media';

export const GRADIENT =
  'linear-gradient(144.01deg, rgba(255, 201, 81, 0.9) 0%, rgba(206, 86, 176, 0.9) 100%)';

export const Page = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  font-family: Urbanist, sans-serif;
  background:
    radial-gradient(ellipse 70% 40% at 0% 0%, rgba(201, 77, 170, 0.05), transparent 55%),
    radial-gradient(ellipse 50% 35% at 100% 0%, rgba(255, 201, 81, 0.06), transparent 50%),
    transparent;

  @media ${device.tablet} {
    padding: 16px;
    gap: 16px;
  }
`;

export const Hero = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: 22px 24px;
  background: linear-gradient(
    135deg,
    rgba(255, 201, 81, 0.16) 0%,
    rgba(206, 86, 176, 0.12) 55%,
    rgba(53, 183, 200, 0.08) 100%
  );
  border: 1px solid rgba(201, 77, 170, 0.12);
  box-shadow: 0 8px 28px rgba(201, 77, 170, 0.08);
`;

export const HeroGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -80px;
  right: -4%;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 201, 81, 0.32) 0%, transparent 70%);
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeroLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
`;

export const BackBtn = styled(Link)`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(23, 23, 23, 0.7);
  flex-shrink: 0;
  transition: all 0.15s ease;
  &:hover {
    color: #c94daa;
    border-color: rgba(201, 77, 170, 0.25);
    transform: translateX(-2px);
  }
`;

export const HeroText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeroBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  padding: 5px 11px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(201, 77, 170, 0.14);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #c94daa;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
`;

export const PageSubtitle = styled.p`
  margin: 4px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.65);
  max-width: 600px;
  line-height: 1.45;
`;

export const HeroActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RefreshIconButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fff;
  color: rgba(23, 23, 23, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    color: #c94daa;
    border-color: rgba(201, 77, 170, 0.3);
  }
`;

export const CreateBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 18px;
  border-radius: 12px;
  border: none;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: ${GRADIENT};
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(201, 77, 170, 0.22);
  transition: all 0.15s ease;
  &:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }
`;

export const StatsStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StatChip = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 6px 18px rgba(23, 23, 23, 0.04);
`;

export const StatIcon = styled.div<{ $tone: string }>`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.$tone};
  background: ${(p) => `${p.$tone}14`};
  flex-shrink: 0;
`;

export const StatValue = styled.div`
  font-size: 22px;
  font-weight: 800;
  color: #171717;
  line-height: 1.1;
`;

export const StatLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 2px;
`;

export const ErrorBanner = styled.div`
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.18);
  color: #dc2626;
  font-size: 14px;
  font-weight: 600;
`;

export const FormAlertBox = styled.div`
  margin: 16px 20px 0;
  padding: 12px 16px;
  border-radius: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`;

// ── Wizard / Creation Panel ──────────────────────────────────────────────

export const CreatePanel = styled.div`
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  box-shadow: 0 10px 30px rgba(23, 23, 23, 0.05);
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(23, 23, 23, 0.06);
`;

export const PanelTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #171717;
`;

export const PanelSubtitle = styled.p`
  margin: 3px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
`;

export const CloseCreatorBtn = styled.button`
  background: none;
  border: none;
  color: rgba(23, 23, 23, 0.4);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.15s ease;
  &:hover {
    color: #171717;
    background: rgba(23, 23, 23, 0.05);
  }
`;

export const WizardBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 20px;
  border-bottom: 1px dashed rgba(23, 23, 23, 0.1);
  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StepBadge = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #c94daa;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const BlockTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #171717;
`;

export const BlockSubtitle = styled.p`
  margin: 2px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: rgba(23, 23, 23, 0.5);
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const HelperText = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
`;

export const Input = styled.input`
  height: 44px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fafafa;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  outline: none;
  transition: all 0.15s ease;
  &:focus {
    border-color: rgba(201, 77, 170, 0.5);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const Select = styled.select`
  height: 44px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fafafa;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='%23c94daa' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-position: right 14px center;
  background-repeat: no-repeat;
  padding-right: 36px;
  transition: all 0.15s ease;
  &:focus {
    border-color: rgba(201, 77, 170, 0.5);
    background-color: #fff;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const FieldGrid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const NoTemplateNotice = styled.div`
  padding: 10px 14px;
  border-radius: 12px;
  background: #fffbeb;
  border: 1px solid #fef3c7;
  font-size: 12px;
  color: #92400e;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const TemplateSnippetCard = styled.div`
  padding: 12px 14px;
  border-radius: 12px;
  background: #fdf4fc;
  border: 1px solid rgba(201, 77, 170, 0.15);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SnippetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SnippetTitle = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #c94daa;
  text-transform: uppercase;
`;

export const SnippetCategory = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(201, 77, 170, 0.12);
  color: #c94daa;
`;

export const SnippetPurposeNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-left: 3px solid #c94daa;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #4b5563;
  line-height: 1.35;
  word-break: break-word;
  strong {
    color: #111827;
    font-weight: 700;
  }
`;

export const SnippetBody = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.45;
`;

export const SnippetFooter = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #6b7280;
  font-style: italic;
`;

// ── Audience Selection ───────────────────────────────────────────────────

export const AudienceRadioGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const RadioCard = styled.div<{ $active: boolean }>`
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid ${(p) => (p.$active ? '#c94daa' : 'rgba(23, 23, 23, 0.1)')};
  background: ${(p) => (p.$active ? '#fdf4fc' : '#fafafa')};
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: #c94daa;
  }
`;

export const RadioDot = styled.div<{ $active: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${(p) => (p.$active ? '#c94daa' : '#d1d5db')};
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  flex-shrink: 0;
  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(p) => (p.$active ? '#c94daa' : 'transparent')};
  }
`;

export const RadioTitle = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #171717;
`;

export const RadioDesc = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(23, 23, 23, 0.55);
  margin-top: 2px;
  line-height: 1.35;
`;

export const AudiencePreviewCard = styled.div`
  padding: 14px 16px;
  border-radius: 14px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AudienceCountWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AudienceCountNumber = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #15803d;
`;

export const AudienceCountLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #166534;
`;

export const RecipientsSampleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  border-top: 1px dashed rgba(22, 101, 52, 0.2);
  padding-top: 8px;
`;

export const RecipientPill = styled.span`
  padding: 3px 8px;
  border-radius: 6px;
  background: #dcfce7;
  font-size: 11px;
  font-weight: 600;
  color: #166534;
`;

// ── Variable Mapping ─────────────────────────────────────────────────────

export const PersonalizationSplitGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 420px;
  gap: 32px;
  align-items: flex-start;

  @media (max-width: 1240px) {
    grid-template-columns: minmax(0, 1fr) 390px;
    gap: 24px;
  }

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const PersonalizationLeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
`;

export const PersonalizationPreviewCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: sticky;
  top: 14px;
  width: 100%;
  padding-right: 20px;
  margin-top: -52px;

  @media (max-width: 960px) {
    align-items: stretch;
    position: static;
    padding-right: 0;
    margin-top: 0;
  }
`;

export const VariablesMappingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
`;

export const VarCard = styled.div`
  padding: 14px;
  border-radius: 14px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VarCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const VarBadge = styled.span`
  padding: 3px 8px;
  border-radius: 6px;
  background: #c94daa;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
`;

export const VarLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #374151;
`;

export const TokenChipsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const TokenChipTitle = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
`;

export const TokenChip = styled.button<{ $isSelected?: boolean }>`
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid ${(p) => (p.$isSelected ? '#c94daa' : '#e5e7eb')};
  background: ${(p) => (p.$isSelected ? 'rgba(201, 77, 170, 0.12)' : '#fff')};
  color: ${(p) => (p.$isSelected ? '#c94daa' : '#4b5563')};
  font-family: Urbanist, sans-serif;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: #c94daa;
    color: #c94daa;
  }
`;

export const PreviewContainer = styled.div`
  border-radius: 24px;
  background: #efeae2;
  border: 1px solid rgba(23, 23, 23, 0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.08);
  max-width: 420px;
  width: 100%;
  min-height: 560px;
`;

export const PhoneHeader = styled.div`
  background: #075e54;
  color: #fff;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
`;

export const PhoneAvatar = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #128c7e;
  color: #fff;
  font-weight: 800;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const PhoneTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
`;

export const PhoneStatus = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
`;

export const PhoneChatArea = styled.div`
  flex: 1;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 14px;
  min-height: 440px;
  background-image: radial-gradient(rgba(0, 0, 0, 0.04) 1px, transparent 1px);
  background-size: 16px 16px;
`;

export const ChatBubble = styled.div`
  align-self: flex-start;
  max-width: 95%;
  background: #ffffff;
  border-radius: 14px;
  border-top-left-radius: 4px;
  padding: 14px 16px 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ChatBody = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #111b21;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const ChatFooter = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #667781;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  padding-top: 6px;
  margin-top: 2px;
`;

export const ChatMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #667781;
  margin-top: 4px;
`;

export const DoubleCheckMark = styled.span`
  color: #53bdeb;
  font-size: 13px;
  font-weight: 700;
`;

export const PreviewButtonsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 95%;
`;

export const PreviewButtonPill = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 10px 16px;
  text-align: center;
  font-size: 13.5px;
  font-weight: 700;
  color: #00a884;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const PreviewFooterNote = styled.div`
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.9);
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
`;

// ── Wallet & Estimation ──────────────────────────────────────────────────

export const WalletEstimateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const EstimateMetricCard = styled.div`
  padding: 14px;
  border-radius: 14px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.06);
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const MetricLabelText = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
`;

export const MetricBigValue = styled.span`
  font-size: 20px;
  font-weight: 800;
  color: #171717;
  line-height: 1.15;
`;

export const MetricSubText = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  color: rgba(23, 23, 23, 0.45);
`;

export const EstimateLoadingBox = styled.div`
  grid-column: 1 / -1;
  padding: 16px;
  border-radius: 12px;
  background: #fafafa;
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
`;

export const EstimatePromptBox = styled.div`
  grid-column: 1 / -1;
  padding: 16px;
  border-radius: 12px;
  background: #fafafa;
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
`;

export const SufficiencyBanner = styled.div<{ $sufficient?: boolean }>`
  padding: 14px 16px;
  border-radius: 14px;
  background: ${(p) => (p.$sufficient ? '#f0fdf4' : '#fef2f2')};
  border: 1px solid ${(p) => (p.$sufficient ? '#bbf7d0' : '#fecaca')};
`;

export const SufficiencyContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const RechargeActionBtn = styled.button`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 10px;
  border: none;
  background: #dc2626;
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.2);
  transition: all 0.15s ease;
  &:hover {
    background: #b91c1c;
  }
`;

export const WizardActionsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
`;

export const SaveDraftBtn = styled.button`
  padding: 0 18px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.15);
  background: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    border-color: #c94daa;
    color: #c94daa;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SecondaryBtn = styled.button`
  padding: 0 18px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.14);
  background: #fff;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.3);
    color: #c94daa;
  }
`;

export const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: ${GRADIENT};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(201, 77, 170, 0.22);
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    opacity: 0.95;
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

// ── List Section ─────────────────────────────────────────────────────────

export const ListPanel = styled.div`
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  box-shadow: 0 8px 24px rgba(23, 23, 23, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const SearchFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 12px;
  border-radius: 10px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.1);
  min-width: 240px;
`;

export const SearchInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #171717;
  width: 100%;
  &::placeholder {
    color: #9ca3af;
  }
`;

export const ClearSearchBtn = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
`;

export const FilterTabs = styled.div`
  display: flex;
  gap: 6px;
  background: #f3f4f6;
  padding: 3px;
  border-radius: 10px;
`;

export const FilterTabBtn = styled.button<{ $active?: boolean }>`
  padding: 6px 12px;
  border-radius: 8px;
  border: none;
  background: ${(p) => (p.$active ? '#fff' : 'transparent')};
  color: ${(p) => (p.$active ? '#171717' : '#6b7280')};
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: ${(p) => (p.$active ? '700' : '600')};
  cursor: pointer;
  box-shadow: ${(p) => (p.$active ? '0 2px 6px rgba(0,0,0,0.06)' : 'none')};
  transition: all 0.15s ease;
`;

export const ListBody = styled.div`
  padding: 20px;
`;

export const EmptyWrap = styled.div`
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CampaignListGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 16px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const CampaignCard = styled.div`
  padding: 18px;
  border-radius: 16px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.08);
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: all 0.15s ease;
  &:hover {
    background: #fff;
    border-color: rgba(201, 77, 170, 0.25);
    box-shadow: 0 8px 24px rgba(201, 77, 170, 0.08);
  }
`;

export const CampaignCardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

export const CampaignDisplayName = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #171717;
`;

export const CampaignMetaInfo = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 3px;
`;

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 999px;
  text-transform: uppercase;
  flex-shrink: 0;
  background: ${(p) => {
    const s = (p.$status || '').toLowerCase();
    if (s === 'completed' || s === 'sent') return 'rgba(34, 197, 94, 0.12)';
    if (s === 'sending') return 'rgba(37, 99, 235, 0.12)';
    if (s === 'failed' || s === 'partial') return 'rgba(239, 68, 68, 0.12)';
    return 'rgba(107, 114, 128, 0.12)';
  }};
  color: ${(p) => {
    const s = (p.$status || '').toLowerCase();
    if (s === 'completed' || s === 'sent') return '#16a34a';
    if (s === 'sending') return '#2563eb';
    if (s === 'failed' || s === 'partial') return '#dc2626';
    return '#4b5563';
  }};
`;

export const CampaignMetricsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
`;

export const MetricTile = styled.div`
  padding: 8px 10px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.05);
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const MetricTileVal = styled.span`
  font-size: 14px;
  font-weight: 800;
  color: #171717;
`;

export const MetricTileLbl = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  color: rgba(23, 23, 23, 0.5);
`;

export const CampaignCardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
`;

export const LaunchDraftBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 8px;
  border: none;
  background: ${GRADIENT};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    opacity: 0.95;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ViewDetailsBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 8px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: #c94daa;
    color: #c94daa;
    background: #fdf4fc;
  }
`;

// ── Modals ───────────────────────────────────────────────────────────────

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const ModalBox = styled.div`
  width: 100%;
  max-width: 440px;
  border-radius: 20px;
  background: #fff;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalBoxLarge = styled.div`
  width: 100%;
  max-width: 760px;
  max-height: 85vh;
  border-radius: 20px;
  background: #fff;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
`;

export const ModalHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
`;

export const ModalHeading = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #171717;
`;

export const ModalSubHeading = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 2px;
`;

export const CloseModalBtn = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  color: rgba(23, 23, 23, 0.4);
  cursor: pointer;
  padding: 4px;
  &:hover {
    color: #171717;
  }
`;

export const ModalText = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.7);
  line-height: 1.5;
`;

export const ModalBtnRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
`;

export const LoadingDetailWrap = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #6b7280;
  font-size: 13px;
`;

export const DetailModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow-y: auto;
  padding-right: 4px;
`;

export const DetailSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const SummaryCard = styled.div`
  padding: 14px 16px;
  border-radius: 14px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.08);
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SummaryLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
`;

export const SummaryValue = styled.span`
  font-size: 20px;
  font-weight: 800;
  color: #171717;
`;

export const SummarySub = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(23, 23, 23, 0.45);
`;

export const RecipientsTableWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TableTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  color: #171717;
`;

export const NoRecipientsBox = styled.div`
  padding: 24px;
  border-radius: 12px;
  background: #fafafa;
  color: #9ca3af;
  font-size: 13px;
  text-align: center;
`;

export const RecipientsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  th {
    text-align: left;
    padding: 8px 10px;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    font-size: 11px;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
  }
  td {
    padding: 10px;
    border-bottom: 1px solid #f3f4f6;
    color: #1f2937;
    vertical-align: middle;
  }
`;

export const AlbumSelectActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const AlbumActionsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AlbumActionBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #c94daa;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    color: #a8328b;
    text-decoration: underline;
  }
`;

export const campaignSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: '44px',
    borderRadius: '12px',
    border: state.isFocused ? '1px solid rgba(201, 77, 170, 0.6)' : '1px solid rgba(23, 23, 23, 0.12)',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(201, 77, 170, 0.1)' : 'none',
    fontSize: '14px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 500,
    background: '#ffffff',
    cursor: 'pointer',
    '&:hover': {
      borderColor: 'rgba(201, 77, 170, 0.6)',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '4px 12px',
    gap: '4px',
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: 'rgba(23, 23, 23, 0.4)',
    fontSize: '13px',
    fontFamily: 'Montserrat, sans-serif',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    padding: '4px 12px',
    color: '#6b7280',
    '&:hover': { color: '#c94daa' },
  }),
  clearIndicator: (base: any) => ({
    ...base,
    padding: '4px 8px',
    color: '#6b7280',
    '&:hover': { color: '#dc2626' },
    cursor: 'pointer',
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '10px',
    marginTop: '4px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    backgroundColor: '#ffffff',
    border: '1px solid rgba(23, 23, 23, 0.08)',
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, state: any) => {
    const isCreateNew = state.data?.value === "__CREATE_NEW_TEMPLATE__";
    return {
      ...base,
      fontSize: '13px',
      fontFamily: 'Montserrat, sans-serif',
      cursor: 'pointer',
      backgroundColor: state.isSelected
        ? 'rgba(201, 77, 170, 0.9)'
        : state.isFocused
          ? isCreateNew
            ? 'rgba(201, 77, 170, 0.12)'
            : 'rgba(201, 77, 170, 0.08)'
          : isCreateNew
            ? 'rgba(201, 77, 170, 0.04)'
            : '#ffffff',
      color: state.isSelected ? 'white' : isCreateNew ? '#c94daa' : '#171717',
      fontWeight: isCreateNew ? 700 : state.isSelected ? 600 : 500,
      borderBottom: isCreateNew ? '1px dashed rgba(201, 77, 170, 0.25)' : 'none',
      '&:active': {
        backgroundColor: 'rgba(201, 77, 170, 0.2)',
      },
    };
  },
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: 'rgba(201, 77, 170, 0.12)',
    borderRadius: '6px',
    padding: '2px 4px',
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: '#9d174d',
    fontWeight: 600,
    fontSize: '12px',
    fontFamily: 'Montserrat, sans-serif',
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: '#9d174d',
    cursor: 'pointer',
    borderRadius: '4px',
    ':hover': {
      backgroundColor: 'rgba(201, 77, 170, 0.25)',
      color: '#831843',
    },
  }),
};
